<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import news from "../../../Data/ComponentData/WidgetData/Genral/NewsData.json";
  import FeatherIcon from "svelte-feather-icon";
</script>

<Col xl="6" class="xl-50 box-col-12">
  <div class="widget-joins card">
    <Row>
      {#each news.Newsdata as widgetItem}
        <Col sm="6" class="pe-0">
          <div class="media border-after-xs">
            <div class="align-self-center me-3">
              {widgetItem.percentage}<i class="fa fa-angle-{widgetItem.arrow} ms-2" />
            </div>
            <div class="media-body details ps-3">
              <span class="mb-1">{widgetItem.status}</span>
              <h5 class="mb-0 counter">{widgetItem.count}</h5>
            </div>
            <div class="media-body align-self-center text-end">
              <FeatherIcon
                class="font-primary float-end ms-2"
                icon={widgetItem.icon}
              />
            </div>
          </div>
        </Col>
      {/each}
    </Row>
  </div>
</Col>
